import {
  SYSTEM_RULE_START_OF_SHIFT_MESSAGE_ERROR,
  SYSTEM_RULE_END_OF_SHIFT_MESSAGE_ERROR,
} from '@/src/constants/system-rule-messages.constant.js'

const isSystemRulesException = (error) => {
  return (
    error?.response?.data?.error &&
    [
      SYSTEM_RULE_START_OF_SHIFT_MESSAGE_ERROR,
      SYSTEM_RULE_END_OF_SHIFT_MESSAGE_ERROR,
    ].includes(error?.response.data.error)
  )
}

export default isSystemRulesException
